<template>
	<div class="partial partial--artist">
		<button-gallery v-on:click.native="show = !show" v-bind:class="{ 'button-gallery--open': show }"></button-gallery>
		<content-band>
			<div slot="img-top" class="content-band__image content-band__image-short" :style="bioImage"></div>
			<h3 class="content-band__artist-profile">Artist Profile</h3>
			<h2 class="content-band__title">Gabriel Berrios</h2>
			<p>Growing up in a military family, Gabriel spent much of his childhood abroad in Asia. Tattooing professionally for 9 years, Gabriel's background has made him into a versatile artist with the ability to tackle a wide range of tattooing styles with precision.</p>
			
		</content-band>

		<transition class="transition" name="fade" mode="out-in">
			<div class="artist-container" v-if="show">
				<artists></artists>
			</div>
		</transition>

		<image-grid :images="images"></image-grid>
	</div>
</template>

<script>
// Components
import ContentBand from '@/components/ContentBand'
import ImageGrid from '@/components/ImageGrid'
import ButtonGallery from '@/components/ButtonGallery'
import Artists from '@/components/Artists'

// Export
export default {
	name: 'artist',
	components: {
		ContentBand,
		ImageGrid,
		ButtonGallery,
		Artists,
	},
	data: () => ({
		bioImage: {
			backgroundImage: 'url(' + require('@/assets/images/artist-gabrielberrios.jpg') + ')'
		},
		images: [
			require('@/assets/images/gabe/2.jpg'),
			require('@/assets/images/gabe/4.jpg'),
			require('@/assets/images/gabe/5.jpg'),
			require('@/assets/images/gabe/6.jpg'),
			require('@/assets/images/gabe/7.jpg'),
			require('@/assets/images/gabe/8.jpg'),
			require('@/assets/images/gabe/10.jpg'),
			require('@/assets/images/gabe/12.jpg'),
			require('@/assets/images/gabe/13.jpg'),
			require('@/assets/images/gabe/14.jpg'),
			require('@/assets/images/gabe/15.jpg'),
			require('@/assets/images/gabe/gabe-11.jpg'),
			require('@/assets/images/gabe/gabe-12.jpg'),
			require('@/assets/images/gabe/gabe-13.jpg'),
			require('@/assets/images/gabe/gabe-14.jpg'),
			require('@/assets/images/gabe/gabe-15.jpg'),
			require('@/assets/images/gabe/gabe-16.jpg'),
			require('@/assets/images/gabe/gabe-17.jpg'),
			require('@/assets/images/gabe/gabe-18.jpg'),
			require('@/assets/images/gabe/19.jpg'),
			require('@/assets/images/gabe/20.jpg'),
			require('@/assets/images/gabe/21.jpg'),
			require('@/assets/images/gabe/22.jpg'),
			require('@/assets/images/gabe/23.jpg'),
			require('@/assets/images/gabe/24.jpg'),
		],
		show: false
	}),
	metaInfo() {
		return {
			title: 'Gabriel Berrios',
			titleTemplate: '%s | Mike Parsons Ink',
		}
	},
}
</script>

<style lang="scss" scoped>

	.artist-container {
		position: fixed;
		top: 0;
		left:0;
		right:0;
		bottom:0;
		z-index: 32;
		overflow: auto;
		transform: translateY(0);
		transition: transform 400ms $easing-material, opacity 200ms $easing-material;

		&.fade-enter-active {
			//transition: opacity .5s;
			top: 100%;
			transform: translateY(100%);
			
		}

		&.fade-leave-active {
			opacity: 0;
			transform: translateY(100%);
		}
	}

	
</style>
